var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef, useState } from "react";
import { Splide, SplideSlide, SplideTrack, } from "@splidejs/react-splide";
import { FlechasSliders } from "../../common/FlechasSlider/FlechasSlider";
import { useAppDispatch, useAppSelector, } from "../../../hooks/customReduxHooks";
import modalSlice from "../../../redux/data/modal";
import Loading from "../../Loading";
import { useHandlerCDNMultimedia } from "../../../hooks/useHandlerCDNMultimedia";
import { getEmpresa } from "../../../redux/data/empresa";
import "@splidejs/react-splide/css";
import { AllImagesContainer, ImageContainer, MultimediaGalleryContainer, SelectedImageContainer, } from "./MultimediaGalleryStyled";
var mainOptions = {
    arrows: false,
    cover: true,
    gap: "1rem",
    heightRatio: 1,
    pagination: false,
    perMove: 1,
    perPage: 1,
    rewind: true,
    type: "slide",
    width: "100%",
    breakpoints: {
        719: {
            pagination: true,
        },
    },
};
var thumbsOptions = {
    arrows: true,
    cover: true,
    gap: "0px",
    isNavigation: true,
    padding: {
        right: "1rem",
        left: "1rem",
    },
    pagination: false,
    perMove: 1,
    perPage: 8,
    rewind: true,
    type: "slide",
    breakpoints: {
        719: {
            perPage: 6,
            arrows: false,
            focus: "center",
        },
    },
};
export var MultimediaGallery = function (_a) {
    var className = _a.className, product = _a.product, selected = _a.selected;
    var _b = useState([]), slides = _b[0], setSlides = _b[1];
    var mainRef = useRef();
    var thumbsRef = useRef();
    var dispatch = useAppDispatch();
    var openModal = modalSlice.actions.openModal;
    var empresaData = useAppSelector(function (state) { var _a; return (_a = state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData; });
    var _c = useHandlerCDNMultimedia(), getCDNMultimedia = _c.getCDNMultimedia, getVideosFromS3ForArticlesOnly = _c.getVideosFromS3ForArticlesOnly;
    useEffect(function () {
        dispatch(getEmpresa());
    }, []);
    useEffect(function () {
        var _a;
        if ((empresaData === null || empresaData === void 0 ? void 0 : empresaData.configuraciones) && ((_a = product === null || product === void 0 ? void 0 : product.multimedia) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            imageProcessor();
        }
    }, [empresaData, product]);
    useEffect(function () {
        if (mainRef.current && thumbsRef.current && thumbsRef.current.splide) {
            mainRef.current.sync(thumbsRef.current.splide);
            if (selected) {
                var index = product.multimedia.findIndex(function (multimedia) { return multimedia.id === selected.id; });
                mainRef.current.splide.go(index);
                thumbsRef.current.splide.go(index);
            }
        }
    }, [mainRef.current, thumbsRef.current, selected]);
    var imageProcessor = function () {
        var newSlides = [];
        if (product === null || product === void 0 ? void 0 : product.multimedia) {
            for (var i = 0; i < product.multimedia.length; i++) {
                var slide = product.multimedia[i];
                var slideUrl = "";
                switch (slide.type) {
                    case "video":
                        slideUrl = getVideosFromS3ForArticlesOnly({
                            path: slide.url,
                            settings: empresaData.configuraciones,
                        });
                        break;
                    case "imagen":
                        slideUrl = getCDNMultimedia({
                            path: slide.url,
                            settings: empresaData.configuraciones,
                            size: "500x500",
                        });
                        break;
                }
                newSlides.push(__assign(__assign({}, slide), { url: slideUrl }));
            }
        }
        setSlides(newSlides);
    };
    var showModal = function (selected) {
        if (className !== "modalMultimedia") {
            dispatch(openModal({
                type: "multimediaGalleryModal",
                data: {
                    imageSelected: selected,
                    product: product,
                },
            }));
        }
    };
    var renderSlides = function (withModal) {
        return slides.map(function (slide) { return (React.createElement(SplideSlide, { key: slide.id },
            React.createElement(ImageContainer, { onClick: function () {
                    return withModal && slide.type === "imagen" && showModal(slide);
                } }, slide.type === "imagen" ? (React.createElement("img", { src: slide.url, alt: slide.name })) : (React.createElement("video", { controls: withModal, preload: "metadata", controlsList: "nodownload" },
                React.createElement("source", { src: slide.url })))))); });
    };
    return slides.length > 0 ? (React.createElement(MultimediaGalleryContainer, null,
        React.createElement(SelectedImageContainer, { className: className },
            React.createElement(Splide, { options: mainOptions, ref: mainRef }, renderSlides(true))),
        React.createElement(AllImagesContainer, { className: className },
            React.createElement(Splide, { options: thumbsOptions, ref: thumbsRef, hasTrack: false },
                React.createElement(FlechasSliders, { estilosFlechas: {} }),
                React.createElement(SplideTrack, null, renderSlides(false)))))) : (React.createElement(Loading, { elemento: "multimedia-gallery" }));
};
